import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger"]
  select(e) {
    this.triggerTarget.checked = false
  }
}
